import { ReactNode } from 'react';

interface FilterSectionProps {
  label: string;
  children: ReactNode;
}

export const FilterSection = ({ label, children }: FilterSectionProps): ReactNode => (
  <div className='activity-feed-filter-section'>
    <span className='activity-feed-filter-label'>{label}</span>
    {children}
  </div>
);
